import { ThemeProvider, standard } from '@creditas-ui/react';
import { Provider } from 'jotai';
import { FormBuilder } from '~/components/FormBuilder';
import { useFormSchema } from '~/hooks';
import { InfrastructureProvider } from '~/shared/infra';
import type { JSX } from 'react';
import type { Origin } from '~/hooks';

const Main = ({ from, value }: Origin): JSX.Element => {
  const { data } = useFormSchema({ from, value });

  return <>{data && <FormBuilder data={data} />}</>;
};

const App = ({ customProps }: { customProps?: Origin }): JSX.Element => {
  const { from = 'Contentful', value = '3WXtS31OLSXt2s1vkr1OK1' } = customProps ?? {};

  return (
    <Provider>
      <ThemeProvider theme={standard}>
        <InfrastructureProvider>
          <Main from={from} value={value} />
        </InfrastructureProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
